/**
 * Agent Runtime Service Locator
 *
 * Provides a dependency injection point so the full-fat agentBaseClass can
 * run headless (agent-runtime) or with full PPT integration (ppt-addin).
 * Host packages call configureAgentServices() at startup to wire up their
 * specific implementations.  All service properties are optional — the
 * agentBaseClass gracefully degrades when a service is absent.
 */
let _services = {};
export function configureAgentServices(services) {
    _services = { ..._services, ...services };
}
export function getAgentServices() {
    return _services;
}
export function hasAgentServices() {
    return _services.getLLMService !== undefined;
}
